// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__q2V7k","row":"styles_row__2NgOD"};